import { TypePolicy } from '@apollo/client';
const mergeFn: TypePolicy['merge'] = (existing, incoming, _options) => {
  if (!existing) {
    return incoming;
  }
  return {
    edges: [...existing.edges, ...incoming.edges],
    pageInfo: incoming.pageInfo,
    __typename: existing.__typename,
  };
};

const TypePolicies = {
  Query: {
    fields: {
      announcements: {
        keyArgs: ['filter', ['departmentIds']],
        merge: mergeFn,
      },
      blockedSlots: {
        keyArgs: ['filter', ['schoolId']],
        merge: mergeFn,
      },
      lessonPackages: {
        keyArgs: [
          'filter',
          ['lessonDefinitionIds', 'startDate', 'endDate', 'teacherState', 'query', 'state', 'teacherId'],
        ],
        merge: mergeFn,
      },
      offlineClasses: {
        keyArgs: ['filter', ['teacherId', 'status', 'nameContains', 'startDate', 'grade'], 'pagination', ['num']],
      },
    },
  },
  // Normalised by `id` (the assignment's), so a refresh mutation's result updates the cached
  // report. Apollo merges it field by field, so a refresh selects every field its card shows.
  // The aggregates and rows have no id of their own: a newer build replaces them whole.
  SelfStudyAssignmentReport: {
    fields: {
      aggregates: { merge: false },
      students: { merge: false },
    },
  },
};

export default TypePolicies;
